import styled, { css } from 'styled-components';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ThemeData } from '../quantData';
import { Link, useNavigate } from 'react-router-dom';
import PageDescription from '../../components/description/Description';
import { isLogin, userGradeType } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';
import GuideSection from '../../guideLanding/GuideSection';

const Quant1 = () => {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();
  const [selectedIndexes, setSelectedIndexes] = useState<number[]>([]);
  const buttonRef = useRef<HTMLDivElement>(null);

  const [isFixed, setIsFixed] = useState(true);
  const [showTooltip, setShowTooltip] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // 버튼 기존 위치 도달
          setIsFixed(false);
          setShowTooltip(false);
        } else {
          setIsFixed(true);
          setShowTooltip(true);
        }
      },
      { threshold: 0.5 },
    );

    if (buttonRef.current) observer.observe(buttonRef.current);
    return () => observer.disconnect();
  }, []);

  const toggleSelect = (index: number) => {
    const item = ThemeData[index];
    setSelectedIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  return (
    <Box gap={24} style={{ padding: '24px 16px 72px' }}>
      <GuideSection type="quant" />
      {/* <Description_Box
        desc1="복잡한 설정 없이, 이미 검증된 빅데이터 전략으로 경매 물건을 추천 받아보세요."
        desc2="설정할 필요 없이, 수십 년 축적된 데이터를 통해 가장 돈 되는 테마별 포트폴리오를 제시합니다."
      /> */}
      <ItemBox>
        {ThemeData.map((item, index) => {
          const isSelected = selectedIndexes.includes(index);

          return (
            <Item
              key={index}
              selected={isSelected}
              onClick={() => toggleSelect(index)}

              // to={'theme?index=' + index + '&region=전국&category=전체'}
            >
              <TextBox>
                <ImageBox>
                  <ItemImage
                    src={item.image}
                    alt=""
                    style={{ width: '44px', height: '44px' }}
                  />
                  <img
                    src={
                      isSelected
                        ? '/assets/images/check/circle-checked-blue.svg'
                        : '/assets/images/check/circle-checked-gray.svg'
                    }
                    alt="선택 여부"
                    width={24}
                    height={24}
                  />
                </ImageBox>
                <ItemName>
                  <span>{item.name}</span>
                  <ThemeStock>宙</ThemeStock>
                </ItemName>
                <p>{item.description}</p>
              </TextBox>
            </Item>
          );
        })}
      </ItemBox>
      <div ref={buttonRef} style={{ height: '10px' }} />
      <ButtonBox fixed={isFixed}>
        {showTooltip && (
          <Tooltip>
            <span>단독 테마, 복합 테마 모두 분석 가능!</span>
          </Tooltip>
        )}
        <BottomButton
          active={selectedIndexes.length > 0}
          onClick={() => {
            if (!isLogin()) {
              modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
              return;
            }
            if (selectedIndexes.length > 0) {
              const queryString = selectedIndexes.join(',');
              navigate(`/quant/theme?indexes=${queryString}`);
            }
          }}
        >
          {selectedIndexes.length > 0
            ? `${selectedIndexes.length}개 테마 분석하기`
            : '테마 분석하기'}
        </BottomButton>
      </ButtonBox>
    </Box>
  );
};

export default Quant1;

const ThemeStock = styled.div`
  width: 22;
  height: 17;
  gap: 10px;
  padding-right: 5px;
  padding-left: 5px;
  border-radius: 4px;
  background: linear-gradient(127.44deg, #008aff 0%, #d224ca 100%);
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #ffffff;
`;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
`;

const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  /* text-align: center; */
  color: ${(props) => props.color};
`;

const ItemBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const Item = styled.div<{ selected: boolean; disabled?: boolean }>`
  text-decoration: none;
  flex: 1 1 calc(50% - 4px);
  max-width: calc(50% - 4px);
  min-height: 150px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => (props.selected ? '#008AFF' : '#e5e8ea')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  background-color: ${({ disabled }) => (disabled ? '#f8f8f8' : '#ffffff')};

  border-radius: 12px;
  padding: 14px 16px;

  ${({ disabled, selected }) =>
    !disabled &&
    css`
      &:hover {
        border: 1px solid ${selected ? '#008AFF' : '#37383c29'};
        box-shadow: 0px 4px 15px 0px #8d95a340;
      }
      &:active {
        background-color: rgba(0, 0, 0, 0.09);
      }
    `}
`;

const ImageBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const ItemImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 16px;
`;
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 7px;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  line-height: 145%;
  letter-spacing: calc(12px * -0.02);
  p {
    margin-block: 0;
    word-wrap: break-word;
    white-space: normal;
  }
`;
const ItemName = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  color: ${({ disabled }) => (disabled ? '#888888' : '#222222')};
`;

const ButtonBox = styled.div<{ fixed: boolean }>`
  position: ${({ fixed }) => (fixed ? 'fixed' : 'relative')};
  bottom: ${({ fixed }) => (fixed ? '0' : 'auto')};
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ fixed }) => (fixed ? '24px 16px' : '0')};
  background: ${({ fixed }) =>
    fixed
      ? 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%)'
      : 'transparent'};
`;

const BottomButton = styled.button<{ active: boolean }>`
  width: 100%;
  border-radius: 8px;
  padding: 14px 28px;
  background-color: ${({ active }) => (active ? '#008AFF' : '#F7F7F8')};
  color: ${({ active }) => (active ? '#FFFFFF' : '#37383C29')};
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  cursor: ${({ active }) => (active ? 'pointer' : 'not-allowed')};
  border: none;
`;

const Tooltip = styled.div`
  padding: 14px;
  border-radius: 8px;
  background-color: #eaf2fe;
  position: absolute;
  transform: translateX(-50%) translateY(12px);
  bottom: 100%;
  left: 50%;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 7px solid transparent;
    border-top-color: #eaf2fe;
    border-bottom: 0;
    margin-left: -8px;
    margin-bottom: -7px;
  }
  span {
    color: #00549b;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
    white-space: nowrap;
  }
`;

const TooltipWrapper = styled.div`
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
`;

const Mask = styled.div`
  width: 100%;
  height: 20px;
  background: linear-gradient(to bottom, #ffffff 80%, rgba(255, 255, 255, 0));
  z-index: 998;
`;
